import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry } from '@cian/mf-registry/browser';
import { getTelemetry } from '@cian/telemetry/browser';
import { v4 as uuid } from 'uuid';

import { IApplicationContext, TApplicationContextCustom } from '../../../shared/types/applicationContext';
import { getBroadcastChannel } from '../../../shared/utils/broadcastChannel';
import { getEventQueue } from '../../../shared/utils/eventQueue/getEventQueue';
import { createMicrofrontendsAPI } from '../microfrontends/createMicrofrontendsAPI';

export function createContext(): IApplicationContext {
  const config = getConfig();

  const { serializableMap, ...custom } = config.getStrict<TApplicationContextCustom>('applicationContext.custom');

  custom.messagesMap = new Map(serializableMap);
  custom.userSessionId = uuid();

  return {
    config: getConfig(),
    logger: getLogger(),
    httpApi: getHttpApi(),
    telemetry: getTelemetry(),
    custom,
    microfrontendsRegistry: registry(),
    microfrontendsAPI: createMicrofrontendsAPI(),
    eventQueue: getEventQueue(),
    broadcastChannel: getBroadcastChannel(),
  };
}
